module.exports = __webpack_public_path__ + "media/images/animated-a90472ee8df7fced810e0bbc2a24fa70.gif";